import { createFileRoute } from "@tanstack/react-router";
import { OrgSettings } from "../../pages/OrgSettings";

export const Route = createFileRoute("/helpdesk/org-settings/")({
  component: OrgSettings,
});
